import React from "react";
import { SlovHeader } from "./slovHeader";
import { useEffect } from "react";
export const SlovGlassScreen = (props) =>
{
    useEffect(() => {
        props.CBcolor("#545454");
    }, []);
    return(
    <div id="game">
    <SlovHeader/> 

<img src = {props.PColors != undefined ? "https://cyberbox.trgu.ru/public/avatars/prot/PlayerMain" + (props.PColors + 1) +".png": "Аватар загружается\n" }></img><React.Fragment><br/></React.Fragment>
<div className ="divtext_slov"><b>{props.prName}</b></div><React.Fragment><br/></React.Fragment>
<div className ="divtext_slov"><b>{props.slovGamePoints}</b> очков</div><React.Fragment><br/></React.Fragment>
<div id = "glassbutton"><button type="button" onClick={(e) =>{props.sendMessage("sendtoserver|slov\\buttonchosen\\hitglass1hp"); console.log("hit");}}>Ударить!</button></div><React.Fragment><br/></React.Fragment>
    </div>
    );
}